// src/constants/volunteerAgeGroups.ts
export const volunteerAgeGroups: Record<string, string> = {
  under18: "Under 18",
  "18plus": "18+",
};

export const volunteerGrades: Record<string, string> = {
  "6th": "6th Grade",
  "7th": "7th Grade",
  "8th": "8th Grade",
  "9th": "9th Grade",
  "10th": "10th Grade",
  "11th": "11th Grade",
  "12th": "12th Grade",
};

export function getVolunteerAgeGroupOptions() {
  return Object.entries(volunteerAgeGroups).map(([value, label]) => ({ value, label }));
}

export function getVolunteerGradeOptions() {
  return Object.entries(volunteerGrades).map(([value, label]) => ({ value, label }));
}
